export default function StreetNumberValidator(message: string) {
  return ({}) => ({
    validator: (_, value) => {
      if (!value) {
        return Promise.resolve(); // Skip validation if the field is empty
      }
      
      const expr = new RegExp(/^[0-9][0-9A-Z\-\/½]*$/, "i");

      if (typeof value.trim === "function") {
        // trim value if it is a string
        value = value.trim();
      }

      if (expr.test(value)) {
        return Promise.resolve();
      } else {
        return Promise.reject(new Error(message));
      }
    },
  });
}
